import { render } from "./DialogTermo.vue?vue&type=template&id=0beea0b2"
import script from "./DialogTermo.vue?vue&type=script&lang=js"
export * from "./DialogTermo.vue?vue&type=script&lang=js"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__